import i18n from '@/i18n/i18n';

/**
 * Formats a date as a relative time string (e.g. "2 days ago", "3 months ago")
 * using the active i18n language.
 */
export function formatRelativeTime(dateString: string | null | undefined): string {
  const unknown = i18n.t('unknown', { ns: 'common' });
  if (!dateString) return unknown;

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return unknown;

  const now = Date.now();
  const diffSec = Math.round((date.getTime() - now) / 1000);
  const absSec = Math.abs(diffSec);

  const locale = i18n.language || 'en';
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

  if (absSec < 60) return rtf.format(diffSec, 'second');
  const diffMin = Math.round(diffSec / 60);
  if (Math.abs(diffMin) < 60) return rtf.format(diffMin, 'minute');
  const diffHour = Math.round(diffSec / 3600);
  if (Math.abs(diffHour) < 24) return rtf.format(diffHour, 'hour');
  const diffDay = Math.round(diffSec / 86400);
  if (Math.abs(diffDay) < 30) return rtf.format(diffDay, 'day');
  const diffMonth = Math.round(diffSec / (86400 * 30));
  if (Math.abs(diffMonth) < 12) return rtf.format(diffMonth, 'month');
  const diffYear = Math.round(diffSec / (86400 * 365));
  return rtf.format(diffYear, 'year');
}
